var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "weekmenucontainer", staticClass: "-mt-md sm:mt-0" },
    [
      _vm.loading
        ? _c("div", { key: "loading", staticClass: "flex justify-center" }, [
            _vm._m(0),
          ])
        : _c(
            "div",
            { staticClass: "grid gap-y-lg sm:gap-x-md grid-cols-12" },
            [
              _vm._l(_vm.weekmenus, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "col-span-12 xs:col-span-4" },
                  [_c("weekmenuitem", { attrs: { content: item } })],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-span-12" },
                [
                  _c("pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "total-pages": _vm.totalPages,
                    },
                    on: {
                      "next-page": function ($event) {
                        return _vm.filter(_vm.currentPage + 1)
                      },
                      "previous-page": function ($event) {
                        return _vm.filter(_vm.currentPage - 1)
                      },
                      "go-to-page": function (event) {
                        return _vm.filter(event.page)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
      },
      [
        _c("i", {
          staticClass:
            "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }